module.exports = __webpack_public_path__ + "img/placeholder.06992237.svg";